import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LocalUserSettingsStorage } from "abweb/service/settings/LocalUserSettingsStorage";
import { ExtensionPoints } from "abweb/utils/plugins/ExtensionPoints";
export class UserSettingsService {
  constructor(storage = new LocalUserSettingsStorage()) {
    this.storage = storage;
  }
  async initialize() {
    // TODO AndyA: make a batch query to get all of the user settings in one request
    Promise.all(UserSettingsService.userSettings.get().map(userSetting => userSetting.initialize()));
  }
}
_defineProperty(UserSettingsService, "userSettings", ExtensionPoints.syncMultiValue());
//# sourceMappingURL=UserSettingsService.js.map
